<div class="col-12">
  <div class="col-12 flex justify-content-center">
    <img src="assets/icons/logo-blue.svg" alt="Genetics Logo" [width]="200" />
  </div>

  <div class="col-12 flex justify-content-center">
    <span class="page-not-found">
      <span class="text-style-1">{{ 'Page_Not_Found.404' | translate }} </span><br />
      {{ 'Page_Not_Found.Page_Not_Found' | translate }}
    </span>
  </div>

  <div class="col-6 col-offset-3 pl-7 flex justify-content-center">
    <span class="message_not_found">{{ 'Page_Not_Found.404_Message' | translate }}</span>
  </div>

  <div class="col-12 flex justify-content-center">
    <span class="what_to_do">{{ 'Page_Not_Found.What_To_Do' | translate }}</span>
  </div>
  <div class="col-offset-3 pl-8">
    <div class="col-8 justify-content-between flex pl-4 pr-8">
      <p-button label="{{ 'Page_Not_Found.Goto_My_Orders' | translate }}"
        (onClick)="navigateToMyOrders()"
        styleClass="p-button-lg p-button-rounded"
        class="p-2" />
      <p-button label="{{ 'Page_Not_Found.Browse_The_Tests' | translate }}"
        (onClick)="navigateToTests()"
        styleClass="p-button-lg p-button-rounded"
        class="p-2 pr-6" />
    </div>
  </div>
</div>
